<template>
  <ModalForm
    title="Add Hold"
    :show="props.show"
    @submit="submit"
    @close="emit('close')"
    :processing="form.processing"
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <InputGroup
          v-model="form.from_date"
          type="date"
          label="From Date"
          :error="form.errors.from_date"
        />
      </div>

      <div>
        <InputGroup
          v-model="form.to_date"
          type="date"
          label="To Date"
          :error="form.errors.to_date"
        />
      </div>

      <div class="col-span-2">
        <InputGroup
          v-model="form.title"
          label="Title"
          :error="form.errors.title"
          placeholder="Short reason for hold"
        />
      </div>

      <div class="col-span-2">
        <LabelErrorContainer
          label="Hold Description"
          :error="form.errors.description"
        >
          <InputTextArea
            v-model="form.description"
            placeholder="Enter a description of the hold, if necessary"
          />
        </LabelErrorContainer>
      </div>
    </div>
  </ModalForm>
</template>

<script setup>
import ModalForm from '@/Common/Overlays/Modals/ModalForm.vue'
import LabelErrorContainer from '@/Common/Forms/Inputs/LabelErrorContainer.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import InputTextArea from '@/Common/Forms/Inputs/InputTextArea.vue'
import { watch } from 'vue'

const props = defineProps({
  show: Boolean,
  plane: Object,
  hold: Object,
})

const emit = defineEmits(['close'])

const form = useForm({
  from_date: null,
  to_date: null,
  title: null,
  description: null,
})

watch(
  () => props.show,
  () => {
    if (props.show && props.hold) {
      form.from_date = props.hold.from_date.slice(0, 10)
      form.to_date = props.hold.to_date.slice(0, 10)
      form.title = props.hold.title
      form.description = props.hold.description
    }
  }
)

function submit() {
  if (props.hold) {
    form.put(route('holds.update', props.hold), {
      onSuccess: () => {
        emit('close')
        form.reset()
      },
    })
  } else {
    form.post(route('planes.holds.store', props.plane), {
      onSuccess: () => {
        emit('close')
        form.reset()
      },
    })
  }
}
</script>
